<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.promotion.title.hotPromotion"
            medium
            sideMenu
        ></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy">
            <div class="-mt-20 mb-4">
                <div>
                    <DashboardSlider
                        ref="dashboard"
                        :apiConfig="dashboardConfig"
                    ></DashboardSlider>
                </div>
                <div class="bg-white p-4">
                    <PromotionList
                        :items="itemsHotPomotion"
                        @onClickItem="onClickPromotionItem($event)"
                    ></PromotionList>
                </div>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>

        <VBottomSheet
            ref="bottomSheetRegister"
            v-model="bottomSheetRegister"
            :persistent="true"
        >
            <div class="px-6 mt-4 text-center">
                <div class="relative flex items-center justify-center">
                    <div class="font-semibold text-lg text-primary uppercase">
                        {{ lbl.bottomSheet.sorry }} !
                    </div>

                    <div class="absolute right-0 top-2">
                        <img
                            src="@/assets/icon/dialog/close.svg"
                            @click="closeRegister()"
                            alt
                        />
                    </div>
                </div>
                <div class="mt-10px">
                    <div
                        class="text-base text-gray-secondary"
                        v-html="lbl.promotion.bottomSheet.register"
                    ></div>
                </div>
                <div class="mt-6 mb-8">
                    <VBtn
                        blocked
                        large
                        variant="primary"
                        @click="goToRegister()"
                        >{{ lbl.register.buttons.register }}</VBtn
                >
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>

        <VBottomSheet
            ref="bottomSheetAddCard"
            v-model="bottomSheetAddCard"
            :persistent="true"
        >
            <div class="px-6 mt-4 text-center">
                <div class="relative flex items-center justify-center">
                    <div class="font-semibold text-lg text-primary uppercase">
                        &nbsp;
                    </div>

                    <div class="absolute right-0 top-2">
                        <img
                            src="@/assets/icon/dialog/close.svg"
                            @click="closeAddCard()"
                            alt
                        />
                    </div>
                </div>
                <div class="mt-10px">
                    <div
                        class="text-base text-gray-secondary"
                        v-html="lbl.promotion.bottomSheet.addCard"
                    ></div>
                </div>
                <div class="mt-6 mb-8">
                    <VBtn
                        blocked
                        large
                        variant="primary"
                        @click="goToProfile()"
                        >{{ lbl.profile.addCard }}</VBtn
                    >
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>
    </div>
</template>

<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import VBtn from "@/components/Button/VBtn.vue";
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import VBottomSheet from "@/components/Dialog/BottomSheet.vue";
import DashboardSlider from "@/components/Dashboard/DashboardSlider.vue";
import PromotionList from "@/module/List/component/PromotionList/PromotionList.vue";

// mixin
import ModalMixin from "@/mixin/ModalMixin";
import LocaleMixin from "@/mixin/LocaleMixin";
import ErrorApiMixin from "@/mixin/ErrorApiMixin";
import PdpaMixin from "@/mixin/PdpaMixin";

// config
import ConfigManager from "@/config/ConfigManager";

// service
import { CampaignListConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel";
import { CampaignListFilterConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel";
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign";

// helper
import { CampaignType } from "@/helper/StaticValue.js";
import CacheHelper from "@/helper/CacheHelper";
import AccountHelper from "@/helper/AccountHelper";

//  composable
import useCreditCardComposable from "@/composables/CreditCardComposable";

export default {
    name: "HotPromotionPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        VBtn,
        ModalMaster,
        VBottomSheet,
        DashboardSlider,
        PromotionList,
    },
    data: function () {
        return {
            hasPoweredBy: false,
            acceptCondition: false,
            bottomSheetRegister: false,
            bottomSheetAddCard: false,
            shouldRegister: false,
            currentDashboard: 0,
            itemsHotPomotion: [],
            dashboardConfig: ConfigManager.getDashboardHotPromotionConfig(),
            campaignListConfig: ConfigManager.getCampaignHotPromotion(),
            configBuilder: new CampaignListConfigBuilder(),
            filterConfig: new CampaignListFilterConfigBuilder(),
            hasCheckUser: false,
            trackingScreenName: "hot_promotion",
            isLoading: false,
            pageYOffsetTemp: 0,
            timerId: null,
        };
    },
    beforeRouteEnter(to, from, next) {
        // prevent access without line idtoken
        var cache = new CacheHelper("session");
        let idToken = cache.getCache("LineIdToken");
        if (idToken == null || idToken == undefined) {
            // redirect to line login
            next({
                path: "/linelogin",
                query: {
                    target_page: "promotion/hot",
                },
            });
        } else {
            next();
        }
    },
    setup: function () {
        const { apiGetCardList, creditCardList } =
            useCreditCardComposable(false);

        return {
            creditCardList,
            apiGetCardList,
        };
    },
    created: function () {
        this.setScrollLoadMore();
        // TODO! comment below line
        // this.configBuilder.setTop(2);
        this.configBuilder.setLocale(this.localeCode);
        this.configBuilder.setConfigList(this.campaignListConfig);
        this.clearCache();
    },
    mounted: function () {
        this.init().then(() => {
            this.getCampaign();
        });

        this.tracking.screenName(this.trackingScreenName);
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    methods: {
        clearCache: function(){
            let cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            cacheHelper.removeCache('isfromlanding');
        },
        init: function () {
            return new Promise((resolve) => {
                let user = AccountHelper.getCacheUser();
                if (user == null) {
                    // show bottom sheet
                    this.bottomSheetRegister = true;
                    this.shouldRegister = true;
                    resolve();
                } else {
                    // try check apply card
                    this.apiGetCardList().then((cards) => {
                        if (cards.length == 0) {
                            this.shouldRegister = true;
                            this.bottomSheetAddCard = true;
                        }
                        resolve();
                    });
                }
            });
        },
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;

                let offsetYNew = window.pageYOffset;
                if (this.pageYOffsetTemp < offsetYNew) {
                    // direction scroll down
                    if (bottomOfWindow) {
                        // debounce load more
                        clearTimeout(this.timerId);
                        this.timerId = setTimeout(() => {
                            this.loadMore();
                        }, 250);
                    }
                }
                this.pageYOffsetTemp = offsetYNew;
            };
        },

        loadMore: function () {
            if (this.isLoading) {
                return;
            } else {
                // set builder
                this.getCampaign();
            }
        },
        getCampaign: function () {
            this.isLoading = true
            return new Promise((resolve) => {
                this.loadingModal.show();

                var params = this.configBuilder.create();
                BzbsCampaign.apiGetCampaign(
                    params,
                    this.filterConfig.create()
                ).subscribe({
                    next: (data) => {
                        this.configBuilder.setSkip(
                            this.configBuilder.campaignListConfig.intSkip +
                                this.configBuilder.campaignListConfig
                                    .defaultTopAmount
                        );

                        this.isLoading = false
                        this.itemsHotPomotion = this.itemsHotPomotion.concat(data);
                        this.loadingModal.hide();
                        resolve(data);
                    },
                    error: (err) => {
                        this.isLoading = false
                        this.loadingModal.hide();
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },
        onClickDotNav: function (idx) {
            this.currentDashboard = idx;
            this.$refs.dashboard.goTo(idx);
        },
        closeRegister: function () {
            // this.$refs.bottomSheetRegister.hide()
            this.goToRegister();
        },
        closeAddCard: function () {
            // this.$refs.bottomSheetAddCard.hide()
            this.goToProfile();
        },
        goToRegister: function () {
            this.$router.push({
                name: "register",
            });
        },
        goToProfile: function () {
            this.$router.push({
                name: "profile",
            });
        },
        onClickPromotionItem: function (campaign) {
            // do nothing if need to register
            // if(this.shouldRegister){
            //     return
            // }

            var tracking_label = campaign.id + "|" + campaign.name;
            this.tracking.event(
                "campaign_list",
                "click_campaign_list",
                tracking_label,
                null
            );

            if (
                campaign.type == CampaignType.News ||
                campaign.type == CampaignType.Event
            ) {
                window.location.href = campaign.customFacebookMessage;
            } else {
                this.$router.push("/promotion/detail/" + campaign.id);
            }
        },
    },
};
</script>
